import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Workspace } from '../types';
import { workspacesApi } from '../services/api';

interface WorkspaceState {
  workspaces: Workspace[];
  activeWorkspaceId: string | null;
  loading: boolean;
  fetchWorkspaces: () => Promise<void>;
  createWorkspace: (data: { name: string; color?: string }) => Promise<Workspace>;
  setActiveWorkspace: (id: string) => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set, get) => ({
      workspaces: [],
      activeWorkspaceId: null,
      loading: false,

      fetchWorkspaces: async () => {
        set({ loading: true });
        try {
          const response = await workspacesApi.getAll();
          const workspaces = response.data as Workspace[];
          const currentIsVisible = workspaces.some(workspace => workspace.id === get().activeWorkspaceId);
          const fallback = workspaces.find(workspace => workspace.is_main) || workspaces[0];
          set({
            workspaces,
            activeWorkspaceId: currentIsVisible ? get().activeWorkspaceId : fallback?.id || null,
            loading: false,
          });
        } catch {
          set({ loading: false });
        }
      },

      createWorkspace: async (data) => {
        const response = await workspacesApi.create(data);
        const workspace = response.data as Workspace;
        set({
          workspaces: [...get().workspaces, workspace],
          activeWorkspaceId: workspace.id,
        });
        return workspace;
      },

      setActiveWorkspace: (id) => set({ activeWorkspaceId: id }),
    }),
    {
      name: 'workspace-storage',
      partialize: state => ({ activeWorkspaceId: state.activeWorkspaceId }),
    }
  )
);
